import React, { useEffect, useState } from 'react';
import ProductList from './components/ProductList';
import { ProductProvider } from './ProductsContext';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Footer from '../../shared/components/Footer';
import { useProducts } from './hooks/useProducts';
import FilterCard from './components/FilterCard';
import Topbar from '../../shared/components/Topbar';
import NavbarComp from '../../shared/components/Navbar';
import { useAuth } from '../auth/hooks/useAuth';
import { useFavorite } from './hooks/useFavorite';
import { useCarts } from './hooks/useCart';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Category from '../../shared/components/Category';
import PromoPage from '../promo/PromoPage';
import TypePage from '../type/TypePage';

const ProductsPage = () => {

  const {
    products,
    searchProductPost,
    loading,
    fetchProducts,
    filterProductPost } = useProducts();
  const { addFavoriteProduct, removeFavoriteProduct } = useFavorite();
  const { addProductCart } = useCarts();


  const navigate = useNavigate();

  let bbb = products;

  const { validate } = useAuth();

  const [user, setUser] = useState()

  const [open, setOpen] = useState(true);
  const [filters, setFilters] = useState({
    category: "",
    price: "",
    age: "",
    type: "",
    sex: ""
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  useEffect(() => {
  }, [
    validate
  ]);

  const handleSearchProduct = (value) => {
    searchProductPost(value)
  }

  const submitFilter = () => {

    const data = {
      sex: filters?.sex,
      categoryString: filters?.category,
      ageGroupProductString: filters?.age,
      starting_price: parseInt(filters?.price) || 0,
      typeProductString: filters?.type,
    }
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== undefined && value !== null && value !== "")
    );

    filterProductPost(filteredData)
  }

  const handleOnAddToCart = (data) => {
    const rowDataAddCart = {
      qty: 1,
      product: data
    }
    addProductCart(rowDataAddCart);
    navigate('/cart');
  }

  const handleAddFavoriteProduct = async (data) => {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we process your request.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      // Simulate an async operation (e.g., API call)
      await new Promise(async (resolve) => {

        addFavoriteProduct({ product: data });
        setTimeout(resolve, 500)
      });

      // After the async operation is complete, close the loading modal
      Swal.close();
    } catch (error) {
      Swal.close();
      Swal.fire('Error!', 'There was a problem processing your request.', 'error');
    }
  }

  return (
    <>
      <NavbarComp searchProduct={handleSearchProduct} />
      <Container style={{
        // backgroundColor: 'white',// Make sure the path is correct
        backgroundPosition: 'top right', // Position the image at the top-right corner
        backgroundSize: 'auto', // Adjust the size of the background image
        height: 'auto', // Make the container take full height (optional)    
        overflowY: 'hidden',
        overflowX: 'hidden',
        paddingBottom: '5%',
        background: 'none'
      }}>

        <Row style={{ paddingBottom: '2rem', paddingTop: '3rem' }}>
          <Col>
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#d9534f",
                  borderRadius: "3px",
                  marginRight: "8px",
                }}
              ></div>
              <span style={{ color: "#8d070e", fontWeight: "600", fontSize: "14px" }}>
                Kategori
              </span>
            </div>
            <h2 className="fw-bold mt-2">Kategori penanganan</h2>
          </Col>
          <Category />
        </Row>

        <ProductProvider>

          <Container className='pt-3 pb-2'>

            {/* <Row className='pt-5 pb-1'>
              <Col xs={12} md={3} className='g-0'>
                <FilterCard
                  open={open}
                  setOpen={setOpen}
                  filters={filters}
                  handleFilterChange={handleFilterChange}
                  submitFilter={submitFilter}
                />
              </Col>
            </Row> */}

            <Row className='pt-1 pb-2'>
              <Col xs={12} md={3} className='g-0' style={{ background: '#8d070e', borderRadius: '1.0rem' }}>
                <Card border='0' style={{ backgroundColor: 'transparent' }}>
                  <Card.Body style={{ backgroundColor: 'transparent' }}>
                    <FilterCard
                      open={open}
                      setOpen={setOpen}
                      filters={filters}
                      handleFilterChange={handleFilterChange}
                      submitFilter={submitFilter}
                    />
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} md={9}>
                <ProductList
                  products={bbb}
                  onAddToFavorites={handleAddFavoriteProduct}
                  onAddToCart={handleOnAddToCart}
                  loading={loading} />
              </Col>
            </Row>
          </Container>

        </ProductProvider>

        <Row style={{
          // backgroundColor: 'white',// Make sure the path is correct
          backgroundPosition: 'top right', // Position the image at the top-right corner
          backgroundSize: 'auto', // Adjust the size of the background image
          // height: '350px', // Make the container take full height (optional)
          paddingBottom: '3rem',
          paddingTop: '3rem'
        }}>
          {/* <Col xs={12} md={3} className='g-0'>
            <FilterCard
              open={open}
              setOpen={setOpen}
              filters={filters}
              handleFilterChange={handleFilterChange}
              submitFilter={submitFilter}
            />
          </Col> */}
          <Col xs={12} md={12} className='g-0'>
            <PromoPage />
          </Col>
        </Row>

        <Row style={{ paddingBottom: '3rem' }}>
          <Col>
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#d9534f",
                  borderRadius: "3px",
                  marginRight: "8px",
                }}
              ></div>
              <span style={{ color: "#d9534f", fontWeight: "600", fontSize: "14px" }}>
                Tipe Layanan
              </span>
            </div>
            <h2 className="fw-bold mt-2">Jelajahi dengan Tipe layanan kami</h2>
          </Col>
          <TypePage />
        </Row>

      </Container>

      <Footer />
    </>
  );
};

export default ProductsPage;
